export default "__VITE_ASSET__BDBkhc15__"